import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';

import {
  Block,
  BlockService,
  Category,
  ConfigService,
  MouseoverDirective,
  ProductionService,
  RouterService,
  SRouterLinkWithHrefDirective,
  TranslateDirective,
  TranslatePipe,
} from '@speedy/core';

export interface CategoryMenu extends Category {
  open: boolean;
}

export const IS_BLOG_ITEMS_SHOW = false;

@Component({
  selector: 'app-header-main-menu',
  templateUrl: './header-main-menu.component.html',
  styleUrls: ['./header-main-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MouseoverDirective,
    NgClass,
    SRouterLinkWithHrefDirective,
    TranslateDirective,
    MatIcon,
    NgTemplateOutlet,
    TranslatePipe,
    AsyncPipe,
  ],
})
export class HeaderMainMenuComponent {
  @HostListener('window:resize', ['$event']) onResize() {
    this.outerWidth = window.outerWidth;
  }

  private readonly configService = inject(ConfigService);
  private readonly renderer = inject(Renderer2);
  private readonly blockService = inject(BlockService);
  private readonly routerService = inject(RouterService);
  private readonly productionService = inject(ProductionService);

  @Input() categories: Category[] = [];

  @Output() childEvent = new EventEmitter();

  timeOutTime = 345;
  outerWidth!: number;
  currentBlogItems: Block[] = [];
  isBlogItemsShow = IS_BLOG_ITEMS_SHOW;

  constructor() {
    if (this.productionService.isServerMode()) return;
    this.outerWidth = window.outerWidth;
  }

  hoverMenuItem(eventObject: MouseEvent) {
    const html = document.getElementsByTagName('html')[0];
    this.renderer.addClass(html, 'sub-nav-open');
    this.renderer.addClass(eventObject.target, 'open');
  }

  blurMenuItem(eventObject: MouseEvent) {
    const html = document.getElementsByTagName('html')[0];
    this.renderer.removeClass(html, 'sub-nav-open');
    this.renderer.removeClass(eventObject.target, 'open');
  }

  getCategoryImage(img: string) {
    if (!img) return '';

    const isIncludes = img?.includes('media/catalog/category');
    return `${isIncludes ? this.configService.get('m2url') : this.configService.getMediaCategoryUrl()}${img}`;
  }

  onSubMenuOpen(category: Category) {
    category.open = true;
    if (this.isBlogItemsShow) {
      this.getBlogItems(category.name);
    }
  }

  getBlogItems(name: string) {
    const slides = this.blockService.blocks();
    const currentSlides: Block[] = [];

    slides.forEach((slide) => {
      if (slide?.identifier?.includes('blog_' + name.toLowerCase())) {
        currentSlides.push(slide);
      }
    });

    this.currentBlogItems.splice(0, this.currentBlogItems.length, ...currentSlides);
    this.currentBlogItems.reverse();
  }

  closeMenu(event: MouseEvent) {
    const html = document.getElementsByTagName('html')[0];
    const active = (event.target as HTMLSpanElement).closest('.nav-item.open');
    if (active) {
      this.renderer.removeClass(active, 'open');
      this.renderer.removeClass(html, 'sub-nav-open');
      this.toggleMenu();
    }
  }

  backAction(category: CategoryMenu, event: MouseEvent) {
    category.open = false;
    const obj = (event.currentTarget as HTMLButtonElement).closest('.nav-item.mob-open');
    this.renderer.removeClass(obj, 'mob-open');
  }

  navigateToCategory = (url_key: string) =>
    this.routerService.navigate(`category/${url_key}`);

  toggleMenu = () => this.childEvent.emit();

  openVaruosad = () => this.routerService.navigate(`/varuosad`);

  only3Level = (category: Category) => parseInt(category.level) < 4;

  categoryImageUrl(image: string) {
    return `${this.configService.getMediaCategoryUrl(true)}${image}`;
  }
}
